import { render, staticRenderFns } from "./WebHooksTable.vue?vue&type=template&id=5e937c38&"
import script from "./WebHooksTable.vue?vue&type=script&lang=js&"
export * from "./WebHooksTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports